module.exports = __webpack_public_path__ + "static/media/infoJumbo3.9a57e889.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/supplier/ziersch/images/infoJumbo3.png
// module id = 472
// module chunks = 0